import AppContext, { ProductContext } from 'context/Context';
import { useContext } from 'react';
import { postToTask } from 'y4/Y4Api';
import y from 'y4/Utils';

const useOrderHook = () => {
  const {
    config: { corp }
  } = useContext(AppContext);

  const {
    productsState: { paymentMethod, cartItems, promo, address }
  } = useContext(ProductContext);

  /**
   * Load data from back end
   * @param {*} action
   */
  const postData = (task, params = {}) => {
    return postToTask(task, { ...params, corp });
  };

  const confirmPay = async params => {
    const ps = {
      paymentMethod,
      cartItems,
      promo,
      address,
      ...params
    };
    const ccuid = y.md5(JSON.stringify(ps));
    return await postData('TASK_ECommerce_New_Order', { ...ps, ccuid });
  };

  const loadOrders = async () => {
    return await postData('TASK_ECommerce_Load_Order_List');
  };

  /**
   *
   * @param {*} id
   * @returns
   */
  const loadOrder = async id => {
    return await postData('TASK_ECommerce_Load_Order_Detail', { id });
  };

  /**
   *
   * @param {*} id
   * @returns
   */
  const completeOrder = async ids => {
    return await postData('TASK_ECommerce_Complete_Order', { ids });
  };

  /**
   *
   * @param {*} id
   * @returns
   */
  const deleteOrder = async ids => {
    return await postData('TASK_ECommerce_Delete_Order', { ids });
  };

  /**
   *
   * @returns
   */
  const loadPoints = async () => {
    return await postData('TASK_ECommerce_Load_Points', {});
  };

  return {
    confirmPay,
    loadOrders,
    loadOrder,
    deleteOrder,
    completeOrder,
    loadPoints
  };
};

export default useOrderHook;
